import { ErrorOutlineOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import useStyles from "./Failure.styles";


const Failure: FC = () => {
    const styles = useStyles();
    const { t } = useTranslation("translation", { keyPrefix: "common.failure" });

    return (
        <div className={styles.container} data-testid="failure">
            <div className={styles.icon}>
                <ErrorOutlineOutlined />
            </div>

            <Typography fontSize={20} fontWeight={600} fontFamily={"Source Sans Pro"}>
                {t("head")}
            </Typography>

            <Typography fontSize={16} fontFamily={"Source Sans Pro"}>
                {t("body")}
            </Typography>
        </div>
    );
};

export default Failure;
